import {get} from "../../../util/api";
import * as type from "./type";

export const findWhatsappMessageList = (processInstanceId) => (dispatch) => {
    dispatch(findWhatsappDeliveredMessageListRequest())

    get('/api/freshchat/get-whatsapp-delivered-messages?processInstanceId=' + processInstanceId)
        .then(whatsappMessageList => {
            dispatch(findWhatsappDeliveredMessageListSuccess(whatsappMessageList))
        })
        .catch(error => {
            dispatch(findWhatsappDeliveredMessageListError(error))
        })
}

export const findWhatsappDeliveredMessageListRequest = () => ({
    type: type.FIND_WHATSAPP_DELIVERED_MESSAGE_LIST_REQUEST,
});

export const findWhatsappDeliveredMessageListSuccess = (whatsappMessageList) => ({
    type: type.FIND_WHATSAPP_DELIVERED_MESSAGE_LIST_SUCCESS,
    payload: {
        whatsappMessageList
    },
});

export const findWhatsappDeliveredMessageListError = (error) => ({
    type: type.FIND_WHATSAPP_DELIVERED_MESSAGE_LIST_ERROR,
    payload: {
        error
    },
});


// WEBPACK FOOTER //
// ./src/modules/whatsapp-messages/state/action.js